import React from "react";
import { Badge } from "reactstrap";
import { themeLabel } from "labels/tr";

const THEME_COLORS = {
  Nature: "success",
  History: "warning",
  Food: "info",
  Adventure: "danger",
  Sea: "primary",
  Culture: "default",
};

export default function ThemeBadge({ theme }) {
  return (
    <Badge color={THEME_COLORS[theme] || "secondary"} className="mr-1" pill>
      {themeLabel(theme)}
    </Badge>
  );
}
